import { forwardRef } from 'react'
import { Button, ButtonProps } from '../button'
import { Loader2 } from 'lucide-react'

export interface ActionButtonProps extends ButtonProps {
  loading?: boolean
}

const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
  ({ loading, children, ...props }, ref) => {
    const disabled = typeof props.disabled === 'boolean' ? props.disabled : loading
    return (
      <Button ref={ref} {...props} disabled={disabled}>
        {loading === true ? <Loader2 className='mr-2 h-4 w-4 animate-spin' /> : children}
      </Button>
    )
  }
)
ActionButton.displayName = 'ActionButton'

export { ActionButton }
